import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT_Mapper extends BaseFormMapper<HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT);

		return _formData;
	}

	MapValues(): Partial<HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT> {
		return {};
	}
}

const Mappings: HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page1[0]",
	year: 'topmostSubform[0].Page1[0].TextField1[5]',
	month: 'topmostSubform[0].Page1[0].TextField1[4]',
	day: 'topmostSubform[0].Page1[0].TextField1[3]',
	re: 'topmostSubform[0].Page1[0].TextField1[2]',
	from: 'topmostSubform[0].Page1[0].TextField1[1]',
	to: 'topmostSubform[0].Page1[0].TextField1[0]',
	// "8":"topmostSubform[0].Page1[0].PrintButton1[0]"
};

export interface HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT {
	to: string;
	re: string;
	from: string;
	day: string;
	month: string;
	year: string;
}
